import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ShareAssetFieldInfo } from '../../fragments/generated/ShareAssetFieldInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareFieldsListMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  fieldsList?: Types.InputMaybe<Array<Types.CollectionFieldInput>>;
}>;


export type UpdateShareFieldsListMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, fieldsList?: { __typename?: 'ShareFieldConnection', totalCount: number, nodes: Array<{ __typename?: 'ShareField', isFrozen?: boolean | null, isVisible?: boolean | null, width?: number | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, name: string } | null } | null> } | null } | { __typename?: 'CollectionShare', id: string, fieldsList?: { __typename?: 'ShareFieldConnection', totalCount: number, nodes: Array<{ __typename?: 'ShareField', isFrozen?: boolean | null, isVisible?: boolean | null, width?: number | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, name: string } | null } | null> } | null } | null } | null };


export const UpdateShareFieldsList = /*#__PURE__*/ gql`
    mutation UpdateShareFieldsList($shareId: ID!, $fieldsList: [CollectionFieldInput!]) {
  updateShare(input: {shareId: $shareId, fieldsList: $fieldsList}) {
    share {
      id
      ... on AssetAggregate {
        fieldsList(page: {first: 100}) {
          nodes {
            ...ShareAssetFieldInfo
          }
          totalCount
        }
      }
    }
  }
}
    ${ShareAssetFieldInfo}` as unknown as DocumentNode<UpdateShareFieldsListMutation, UpdateShareFieldsListMutationVariables>;

          

          export const useUpdateShareFieldsListMutation = (options?:MutationHookOptions<UpdateShareFieldsListMutation, UpdateShareFieldsListMutationVariables>) => useMutation(UpdateShareFieldsList, options);
          

          export type UpdateShareFieldsListMutationOptions = MutationHookOptions<UpdateShareFieldsListMutation, UpdateShareFieldsListMutationVariables>;

          

          export type UpdateShareFieldsListMutationResult = ReturnType<typeof useUpdateShareFieldsListMutation>[1];

          
